<template>
  <v-main class="results-view mb-10 mt-md-0">
    
    <v-row class="results mt-0 mt-md-8 ml-0">
      <v-col cols="12" md="12" class="pl-0 pt-0 pr-0">
        <donor-search-component ref="donorSearchSidebar" :results-page="true" :sidebar="true" />
      </v-col>
      <v-col cols="12" md="12" class="pa-0">
        <results-component id="resultsComponent" v-scroll="onScroll"/>
      </v-col>
    </v-row>
  </v-main>
</template>

<script>
import ResultsComponent from '../components/ResultsComponent.vue';
import DonorSearchComponent from '../components/DonorSearchComponent.vue';
import { mapState, useStore } from "vuex";
import { computed } from "vue"

export default {
  components: {
    ResultsComponent,
    DonorSearchComponent,
  },
  data() {
    return {
      oldValue: 0,
      newValue: 0,
    }
  },
  setup() {
        const store = useStore()
        return {
            totalRecordCount: computed(() => store.getters['resultsModule/getTotalRecordCount']),
            store
        }
    },
  computed: {
    ...mapState('filtersModule',['materialType'])
  },
  mounted() {
    this.$store.dispatch('breadcrumbModule/setRoute', [{
      name: 'breadcrumb.want_to_be_a_parent',
      url: `https://bank.invicta.pl${ this.$t('bank_invicta_path.planning_parenthood') }`,
      absolute: true
    },{
      name: 'breadcrumb.search',
      url: '/'
    },
    {
      name: 'breadcrumb.results',
      url: ''
    }
    ])
  },
  methods: {
    onScroll() {
      let buttonWrapper = document.querySelector('#donorMobileSearchWrapper');
      let button = this.$refs.donorSearch;

      if (buttonWrapper) {
        if(window.pageYOffset < 138) {
            buttonWrapper.style.position = "absolute";
            buttonWrapper.style.top = "138px";
        } else {
          if(button) {
            this.newValue = window.pageYOffset;
            if (this.oldValue < this.newValue) {
              buttonWrapper.style.position = "absolute";
              buttonWrapper.style.top = "138px";
            } else if (this.oldValue > this.newValue) {
              buttonWrapper.style.position = "fixed";
              buttonWrapper.style.top = "0";
              buttonWrapper.style.right = "0";
            }
            this.oldValue = this.newValue;
          }
        }
      }
    },
    setMaterialType(type) {
      this.$refs.donorSearchSidebar.materialType = type;
    },
    resultsCountDeclination() {
      if(this.totalRecordCount == 1) {
        return this.$t('results.nom');
      } else if(this.totalRecordCount <= 4) {
        return this.$t('results.nom_plural');
      } else if(this.totalRecordCount > 4 && this.totalRecordCount < 22) {
        return this.$t('results.gen_plural');
      } else {
        if(
          this.totalRecordCount || 10 == 2 || 
          this.totalRecordCount || 10 == 3 || 
          this.totalRecordCount || 10 == 4
        ){
          return this.$t('results.nom_plural')
        } else {
          return this.$t('results.gen_plural');
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

@media (max-width: 960px) {
  .results-view {
    width: 100% !important;
    margin-left: 0% !important;
  }
}
.results-view {
  width: 80%;
  margin-left: 10%;
}
  .results {
    width: 100%;
  }
  #donorMobileSearchWrapper {
    z-index: 2;
    width: 100%;
    position: absolute;
    top: 138px;
    right: 0px;
  }
  #resultsComponent {
    z-index: 1;
  }

  .sidebar {
    // position: relative;
    // max-width: 400px;
    // float: right;
  }
  .header {
    @include nsb-gentium-bold;
    color: var(--ds-primary, #00205B);
    /* Desktop/Title-01 */
    font-family: Gentium Basic;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 130%; /* 52px */
    &.mobile {
      font-size: 28px;
      display: flex;
      align-items: center;
    }
  }
  .gender-tabs-wrapper {
    
    .gender-tabs {
      .v-tab {
        color: $nsb-color-4;
        font-size: 16px;
        line-height: 24px;
        min-width: 344px;
        background: rgba(238, 244, 254, 1);
        &.v-tab--selected {
          background: white;
          color: $ds-primary;
          :deep(.v-tab__slider) {
            background-color: $nsb-yellow !important;
            max-width: 56px !important;
            margin-left: 50%;
            transform: translateX(-50%);
          }
        }
        border-top-left-radius: 4px !important;
        border-top-right-radius: 4px !important;
      }
    }
  }
</style>